import { render, staticRenderFns } from "./site-warnings-list.component.vue?vue&type=template&id=61580f78"
import script from "./site-warnings-list.component.ts?vue&type=script&lang=ts&external"
export * from "./site-warnings-list.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61580f78')) {
      api.createRecord('61580f78', component.options)
    } else {
      api.reload('61580f78', component.options)
    }
    module.hot.accept("./site-warnings-list.component.vue?vue&type=template&id=61580f78", function () {
      api.rerender('61580f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/warnings-list/site-warnings-list.component.vue"
export default component.exports